import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import HomeHub from './pages/HomeHub';
import Dashboard from './pages/Dashboard';
import ProjectDetail from './pages/ProjectDetail';
import TeamOverview from './pages/TeamOverview';
import TeamDetail from './pages/TeamDetail';
import FinanceDetail from './pages/FinanceDetail';
import ClientReport from './pages/ClientReport';
import ClientsPage from './pages/ClientsPage';
import InvoiceCreator from './pages/InvoiceCreator';
import TrashPage from './pages/TrashPage';
import EngineeringPage from './pages/EngineeringPage';
import UndoManager from './components/UndoManager';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a]"><div className="text-neutral-500">Loading...</div></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a]"><div className="text-neutral-500">Loading...</div></div>;
  if (user) return <Navigate to="/hub" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/hub" element={<ProtectedRoute><HomeHub /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/project/:id" element={<ProtectedRoute><ProjectDetail /></ProtectedRoute>} />
      <Route path="/team" element={<ProtectedRoute><TeamOverview /></ProtectedRoute>} />
      <Route path="/team/:id" element={<ProtectedRoute><TeamDetail /></ProtectedRoute>} />
      <Route path="/finance" element={<ProtectedRoute><FinanceDetail /></ProtectedRoute>} />
      <Route path="/clients" element={<ProtectedRoute><ClientsPage /></ProtectedRoute>} />
      <Route path="/client-report" element={<ProtectedRoute><ClientReport /></ProtectedRoute>} />
      <Route path="/invoice" element={<ProtectedRoute><InvoiceCreator /></ProtectedRoute>} />
      <Route path="/trash" element={<ProtectedRoute><TrashPage /></ProtectedRoute>} />
      <Route path="/engineering" element={<ProtectedRoute><EngineeringPage /></ProtectedRoute>} />
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <UndoManager />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
